import { Vue } from 'vue-property-decorator'
import HigiaCryptoService from 'higia-lib-components/src/lib-components/services/higia-crypto.service'
import HigiaStorageSevice from 'higia-lib-components/src/lib-components/services/higia-storage.service'
import Usuario from 'higia-lib-components/src/lib-components/domains/user.dto'
import HigiaComunicationSevice from 'higia-lib-components/src/lib-components/services/higia-comunication.service'

export default class HigiaPrivilegiosSevice extends Vue {
    _PRIVILEGIOS_KEY = 'grantedAuthorities'
    HigiaCryptoService: HigiaCryptoService
    higiaStorageSevice: HigiaStorageSevice
    usuario = Usuario.getInstance()
    higiaComunicationSevice: HigiaComunicationSevice

    constructor() {
        super()
        this.HigiaCryptoService = new HigiaCryptoService()
        this.higiaStorageSevice = new HigiaStorageSevice()
        this.higiaComunicationSevice = new HigiaComunicationSevice()
        this.getPrivilegios()
    }

    public temPrivilegio(to: any) {
        if (to.meta.requiresAuth == false) {
            return true
        } else {
            const privilegios = this.getPrivilegios()
            const privilegiosRota = this._getPrivilegiosRota(to)
            if (privilegios == null) {
                return false
            } else if (privilegiosRota != null) {
                for (let i = 0; i < privilegiosRota.length; i++) {
                    if (privilegios.indexOf(privilegiosRota[i]) > -1) {
                        return true
                    }
                }
            } else {
                return true
            }
            return false
        }
    }

    public getPrivilegios = () => {
        try {
            const privilegios = JSON.parse(
                this.HigiaCryptoService.decrypt(this.higiaStorageSevice.get(this._PRIVILEGIOS_KEY))
            )
            this.usuario.privilegios = privilegios
            return privilegios.map((item: string) => {
                return item.replace('ROLE_', '')
            })
        } catch (error) {
            return null
        }
    }

    public _getPrivilegiosRota(to: any) {
        if (to.meta.roles) {
            return to.meta.roles
        } else {
            for (let i = to.matched.length - 2; i >= 0; i--) {
                if (to.matched[i].meta.roles) {
                    return to.matched[i].meta.roles
                }
            }
            return null
        }
    }

    public setPrivilegios(privilegios: any) {
        this.usuario.privilegios = privilegios
        this.higiaStorageSevice.set(this._PRIVILEGIOS_KEY, this.HigiaCryptoService.encrypted(privilegios, true))
        //Linhas só para funcionamento local

        this.higiaComunicationSevice.sendPostMessageFromSonToFather(
            this.HigiaCryptoService.encrypted(privilegios, true),
            'grantedAuthorities',
            false
        )
        //FIM Linhas só para funcionamento local
    }

    public updatePrivilegiosKey(privilegios: any) {
        this.higiaStorageSevice.remove(this._PRIVILEGIOS_KEY)
        if (privilegios && privilegios.length) {
            this.setPrivilegios(privilegios)
        }
    }

    public _privilegioAcao(permissaoValor: any, privilegios: any) {
        if (privilegios && privilegios.length) {
            const permissao = privilegios.filter((item: any) => item == permissaoValor).length
            if (permissao) {
                return true
            } else {
                return false
            }
        }
        return false
    }

    public getPermissoes(perfil: string) {
        switch (perfil) {
            case 'MEDICO':
                return this.compararPrivilegios('MEDICO')
            case 'MEDICO_RESPONSAVEL':
                return this.compararPrivilegios('MEDICO_RESPONSAVEL')
            case 'CREDENCIAMENTO':
                return this.compararPrivilegios('CREDENCIAMENTO')
            case 'CAM':
                return this.compararPrivilegios('CAM')
            case 'JURIDICO':
                return this.compararPrivilegios('JURIDICO')
            case 'CADASTRO':
                return this.compararPrivilegios('CADASTRO')
            default:
                return null
        }
    }

    public compararPrivilegios = (permissao: any) => {
        const privilegios = this.getPrivilegios()
        if (privilegios && privilegios.length) {
            return this._privilegioAcao(permissao, privilegios)
        }
        return null
    }
}
